export default __webpack_public_path__ + "static/media/mobile-unauthenticated-logo.3806a3b1.svg";